////////////////////////////////////////////////////////////
//     							                                      //
//  Program: EventType.jsx                                //
//  Application: Misc                                     //
//  Option: to view EventType data                        //
//  Developer: Ashish Kumar                               //
//  Date: 2022-01-11                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import {
  // Button,
  Table,
  Modal,
  Form,
} from "react-bootstrap";
import Alerts from "../common/Alerts";
// import deleteicon from "../../assets/images/delete.svg";
import SimpleReactValidator from "simple-react-validator";
import modaldeleteicon from "./../../assets/images/delete.svg";
import EventTypeService from "../../services/EventTypeService";
// import pluswIcon  from './../../assets/images/plus.svg';
import { Container } from "react-bootstrap";
import MasterSidebar from "../common/MasterSidebar";
import NoData from "../common/NoData";

export class EventType extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      open: global.showOpen,
      eventKey: "",
      input: {},
      errors: {},
      toggleSwitchDark2: true,
      status_id: true,
      slug: "",
      //for Event type
      addEventTypeModal: false,
      editEventTypeModal: false,
      deleteEventTypeModal: false,
      eventTypeList: [],
      eventTypeListTotal: 0,
      event_type_name: "",
      sort_order: "",
    };
    this.changeHandler = this.changeHandler.bind(this);

    /* for EventType */
    this.openAddEventTypeModal = this.openAddEventTypeModal.bind(this);
    this.openEditEventTypeModal = this.openEditEventTypeModal.bind(this);
    this.openDeleteEventTypeModal = this.openDeleteEventTypeModal.bind(this);
    this.saveEventType = this.saveEventType.bind(this);
    this.getEventTypeDetails = this.getEventTypeDetails.bind(this);
    this.updateEventType = this.updateEventType.bind(this);
    this.deleteEventType = this.deleteEventType.bind(this);
  }

  componentDidMount() {
    this.getEventTypeData();
  }

  /* To get EventType list data */
  async getEventTypeData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var eventTypeList = [];
    var eventTypeListTotal = 0;

    let res = await EventTypeService.getEventType(
      queryString ? "&" + queryString : ""
    );

    if (global.successStatus.includes(res.status)) {
      eventTypeList = res.data.data ? res.data.data : [];
      eventTypeListTotal = eventTypeList ? eventTypeList.length : 0;
    }
    this.setState({
      eventTypeList: eventTypeList,
      eventTypeListTotal: eventTypeListTotal,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  /* To save EventType data */
  saveEventType = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.event_type_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        event_type_name: this.state.event_type_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await EventTypeService.createEventType(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeAddEventTypeModal();
        this.setState({
          event_type_name: "",
          sort_order: "",
          status_id: true,
        });
        this.getEventTypeData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to get EventType details data  */
  async getEventTypeDetails(slug) {
    this.setState({ showSpinner: true, isSubmit: true });
    if (slug) {
      var resData = {};
      let res = await EventTypeService.getEventTypeBySlug(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resData.event_type_name = res.data.event_type_name
          ? res.data.event_type_name
          : "";
        resData.sort_order = res.data.sort_order ? res.data.sort_order : "";
        resData.status_id = res.data.status_id === 1 ? true : false;
      }
      this.setState(resData);
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  /* to update EventType data */
  updateEventType = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.event_type_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        event_type_name: this.state.event_type_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await EventTypeService.updateEventType(
        this.state.slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeEditEventTypeModal();
        this.setState({
          event_type_name: "",
          sort_order: "",
          status_id: true,
        });
        this.getEventTypeData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to delete EventType data */
  async deleteEventType(slug) {
    this.setState({ showSpinner: true });
    let res = await EventTypeService.deleteEventType(slug);
    if (global.successStatus.includes(res.status)) {
      this.closeDeleteEventTypeModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });

      this.getEventTypeData();
    } else {
      this.closeDeleteEventTypeModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ showSpinner: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  changeHandler = (EventType) => {
    let input = this.state.input;
    let value =
      EventType.target.type === "checkbox"
        ? EventType.target.checked
        : EventType.target.value;
    input[EventType.target.name] = value;
    this.setState({ [EventType.target.name]: value, input: input });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  /* EventType Modals */
  openAddEventTypeModal() {
    this.setState({ addEventTypeModal: true });
  }

  closeAddEventTypeModal() {
    this.setState({ addEventTypeModal: false });
    this.setState({
      event_type_name: "",
      sort_order: "",
      errors: "",
      status_id: true,
    });
    this.validator.hideMessages();
  }

  openEditEventTypeModal(slug) {
    this.getEventTypeDetails(slug);
    this.setState({ editEventTypeModal: true });
    this.setState({ slug: slug });
  }

  closeEditEventTypeModal() {
    this.setState({ editEventTypeModal: false });
    this.setState({
      slug: "",
      event_type_name: "",
      sort_order: "",
      errors: "",
      status_id: true,
    });
    this.validator.hideMessages();
  }

  openDeleteEventTypeModal(slug) {
    this.setState({ deleteEventTypeModal: true });
    this.setState({ slug: slug });
  }

  closeDeleteEventTypeModal() {
    this.setState({ deleteEventTypeModal: false });
    this.setState({ slug: "" });
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.id });
    const scrollId = document.getElementById(e.target.id);
    scrollId.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }

  getTitle() {
    return "Event Type";
  }

  render() {
    return (
      <>
        {/* EventType card */}
        {/* <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="7"
              id="7"
              onClick={(e) => this.setOpen(!this.state.open, e)}
            >
              Event Type
              <i className="mdi mdi-view-headline"> </i>
              {this.state.open && this.state.eventKey === "7" ? (
                <i className="fas fa-chevron-down"></i>
              ) : (
                <i className="fas fa-chevron-up"></i>
              )}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="7">
            <Card.Body>
              <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
                <Button
                  variant="outline-dark btn-block btn-with-icon"
                  onClick={this.openAddEventTypeModal}
                >
                  <img src={pluswIcon}/> Add
                </Button>
              </div>
              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                />
              </div>
              <div className="table-responsive">
                <Table hover className="mg-b-0">
                  <thead>
                    <tr>
                      <th className="w-50">Event Type Name</th>
                      <th className="w-25">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.eventTypeListTotal > 0 ? (
                      this.state.eventTypeList.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td className="hand-cursor"  onClick={() =>
                                    this.openEditEventTypeModal(item.slug)
                                  }>{item.event_type_name}</td>
                            <td>
                              {item.status_id === 1 ? (
                                <b className="active"></b>
                              ) : (
                                <b></b>
                              )}
                            </td>
                            <td>
                              <div className="btn-icon-list d-block text-center">
                                <img
                                  src={deleteicon}
                                  alt="Delete"
                                  onClick={() =>
                                    this.openDeleteEventTypeModal(item.slug)
                                  }
                                  className="hand-cursor"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" align="center">
                          No rows found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card> */}

        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <aside>
                      <MasterSidebar />
                    </aside>
                  </div>
                </div>
                <div className="col-md-10 right settingsidebarNav">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      {/* <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
              <Button
                variant="outline-dark btn-block btn-with-icon"
                onClick={this.openAddAffordableTypeModal}
              >
                <img src={pluswIcon} /> Add
              </Button>
            </div> */}
                    </div>
                  </div>
                  <div className="master">
                    <div className="table-responsive">
                      {/* <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
            <Button
              variant="outline-dark btn-block btn-with-icon"
              onClick={this.openAddEventTypeModal}
            >
              <img src={pluswIcon}/> Add
            </Button>
          </div> */}
                      <div className="col-md-12 pl-0 pr-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.eventTypeListTotal > 0 ? (
                        <Table hover className="mg-b-0">
                          <thead>
                            <tr>
                              <th className="w-50">Event Type Name</th>
                              <th className="w-25">Status</th>
                              {/* <th className="text-center">Action</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.eventTypeListTotal > 0 ? (
                              this.state.eventTypeList.map((item, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                      className="hand-cursor"
                                      onClick={() =>
                                        {
                                         global.userPermissions.checkPermission(
                                           "master-data-update"
                                         ) && (this.openEditEventTypeModal(item.slug))
                                       }}
                                    >
                                      {item.event_type_name}
                                    </td>
                                    {/* <td>{item.event_type_name ? item.event_type_name : ""}</td> */}
                                    <td>
                                      {item.status_id === 1 ? (
                                        <b className="active"></b>
                                      ) : (
                                        <b></b>
                                      )}
                                    </td>
                                    {/* <td>
                        <div className="btn-icon-list d-block text-center">
                          <img
                            src={deleteicon}
                            alt="Delete"
                            onClick={() =>
                              this.openDeleteEventTypeModal(item.slug)
                            }
                            className="hand-cursor"
                          />
                        </div>
                      </td> */}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9" align="center">
                                  There are no event types added in the system.
                                  You may add them by clicking Add button.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <NoData
                          msg={global.commonMessages.checkMessage("EVENTTYPE")}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* add EventType popup modal */}
        <Modal
          show={this.state.addEventTypeModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddEventTypeModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddEventTypeModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Add Event Type</h3>
            <label>Event Type Name</label>
            <Form.Control
              onChange={this.changeHandler}
              name="event_type_name"
              value={this.state.event_type_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              // placeholder="Event Type Name"
            />
            {this.state.errors.event_type_name ? (
              <div className="text-danger">
                {this.state.errors.event_type_name}
              </div>
            ) : (
              this.validator.message(
                "event_type_name",
                this.state.event_type_name,
                "required",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddEventTypeModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.saveEventType}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* edit EventType popup modal */}
        <Modal
          show={this.state.editEventTypeModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditEventTypeModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditEventTypeModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Event Type</h3>
            <label>Event Type Name</label>
            <Form.Control
              onChange={this.changeHandler}
              name="event_type_name"
              value={this.state.event_type_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              // placeholder="Event Type Name"
            />
            {this.state.errors.event_type_name ? (
              <div className="text-danger">
                {this.state.errors.event_type_name}
              </div>
            ) : (
              this.validator.message(
                "event_type_name",
                this.state.event_type_name,
                "required",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditEventTypeModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.updateEventType}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete EventType popup modal */}
        <Modal
          show={this.state.deleteEventTypeModal}
          // onHide={() => {
          //   if (
          //     window.confirm("Are you sure to exit the pop up without delete?")
          //   )
          //     this.closeDeleteEventTypeModal();
          // }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span
                className="welcomeClose"
                onClick={() => this.closeDeleteEventTypeModal()}
              >
                {global.closee}
              </span>
              <img src={modaldeleteicon} alt="modal-delete-icon" />
              <h3>Delete the Option?</h3>
              <p>
                Do you really want to delete this option? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteEventTypeModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteEventType(this.state.slug)}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default EventType;
